export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-ru-2-8ca755775f7f97d33b9c87df63eadee5.png";